tocbot.init({
    // Where to render the table of contents.
    tocSelector: '.post-toc',
    // Where to grab the headings to build the table of contents.
    contentSelector: '.gh-content',
    // Which headings to grab inside of the contentSelector element.
    headingSelector: 'h1, h2, h3, h4',
    hasInnerContainers: true,
    scrollContainer: true,
    scrollSmooth: true,
    scrollSmoothOffset: -20,
    // Smooth scroll duration.
    throttleTimeout: 10,
    scrollSmoothDuration: 300,
});